<template>
  <div class="coupon-wrapper">
    <div>
      <img src="https://oss.aqdpay.com/appweb/psbcActive/millionRed/psbc_million_red_coupon.png" alt="" width="100%">
    </div>
    <div class="intro-tip-2" @click="goIntro"></div>
  </div>
</template>

<script>
import { getYcCoupons } from '@/api/active'
import { setStore } from '@/utils/index'
import { Dialog, Toast } from 'vant'
export default {
  data () {
    return {
    }
  },
  mounted () {
    const token = this.$route.query.accessToken
    if (token) {
      console.log(token)
      setStore('token', token)
    } else {
      this.goLogin()
    }
  },
  methods: {
    goLogin () {
      /* eslint-disable */
      dsBridge.call('callLogin',function(res) {
        const token = res
        if (res) {
          setStore('token', token)
        }
      })
    },
    goIntro () {
      this.getYcCoupon()
    },
    getYcCoupon () {
      const query = {
        couponsType: 2,
      }
      getYcCoupons(query).then((res) => {
        const r = res.data.result
        if (r && (r.code === 0 || r.code === 1)) {
          Dialog.alert({
            title: '加油券领取',
            message: r.msg,
            theme: 'round-button',
            confirmButtonText:r.code === 1? '去使用':'知道了'
          }).then(() => {
              const data = r.appJumpInfoDTO
              // 跳转到原生界面
              /* eslint-disable */
              dsBridge.call('callNativeViewLifeCycle', {
                androidGoPage: data.androidGoPage,
                iosGoPage: data.iosGoPage,
                appId: data.appId,
                appType: data.appType,
                appStartUrl: data.appStartUrl,
                login: data.login,
                addToolbar: data.addToolbar
              })
            })
        } else {
          Toast({
            message: r.msg
          })
        }
      })
    },
  }
}

</script>
<style lang='scss' scoped>

.coupon-wrapper {
  position: relative;
  min-height: 100vh;
  img {
    display: block;
    width: 100%;
  }
  .intro-tip {
    position: absolute;
    top: 25%;
    width: 100%;
    height: 12%;
  }
  .intro-tip-2 {
    position: absolute;
    top: 20%;
    width: 100%;
    height: 13%;
  }
  .bottom {
    position: absolute;
    bottom: 25%;
    width: 100%;
    height: 12%;
  }
}

</style>
